import React from "react";
import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CustomizedButton from "src/modules/ui-elements/CustomizedButton";
import { useSelector } from "react-redux";
import { longPollJobDetails, updateRawImageInEditorObject, updateJobBatchEditor } from "src/modules/editor-v2/services/Jobs";
import { atom, useAtom, useAtomValue } from "jotai";
import { activeProjectAtom, pageAtom,selectedTemplateAtom, fileCountAtom} from "src/modules/batchEditor/atoms";
import { CircularProgress } from "@mui/material";
import useToast from "@/hooks/useToast";
import { useRouter } from "next/router";
import useAuth from '@/hooks/useAuth';
import { BULK_AI_TYPE } from "@/utils/toolsConstants";

export default function BatchEditorSuccessDialog(props) {
  const { open, onClose, isBulkAIType=false } = props;
  const [isLoading, setisLoading] = useState(false);
  const { jobId} = useSelector((state) => state.jobs);
  const {bulkUplodAIType} = useSelector(state => state.fileUpload);
  const [fileCount, setFileCount] = useAtom(fileCountAtom);
  const {entireStrapiData} = useSelector((state)=> state.strapi)
  const strapiData = entireStrapiData?.StudioBatchEditorText?.StudioBatchEditorText;
  const toaster = useToast();
  const router = useRouter();
  const {user} = useAuth();

  const longPollJobDetail = async () => {
    if(isBulkAIType){
        props?.saveProject(true);
        closeDialog();
      return;
    }
    try{
    toaster.info("Loading Please wait");
    setisLoading(true);
    await longPollJobDetails(jobId);
    //Fallback update as screen will be updated as per the uplod journey in homePage
    const presetDetails = {
      size: {
          height: 1500,
          width: 1500
      },
      coverage: 80,
      position: "centre",
      backgroundColor: "#FFFFFF",
    }
    await updateJobBatchEditor(jobId, presetDetails);
    router.push(`/dashboard/batch-editor/${jobId}`);
    closeDialog()
    setisLoading(false);
    }catch(error){
      setisLoading(false);
      toaster.error("Some error occured, Please try again");
    }
  };

  const updateRawImageInEditor = async () => {
    if(isBulkAIType){
      props?.saveProject(false);
      closeDialog();
      return;
    };
    setisLoading(true);
        try {
            toaster.info("Loading Please wait");
            const res= await longPollJobDetails(jobId, 1000);
            const result = await updateRawImageInEditorObject(jobId);
            router.push(`/dashboard/batch-editor/${jobId}`);
        } catch (error) {
            console.error("Error updating job:", error);
            toaster.error("Some error occured, Please try again");
        }
        setisLoading(false);
    }
  const closeDialog = () => {
    if(!isLoading) 
    { onClose();
      setFileCount(0);}
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          backgroundColor: "white",
          margin: 0,
          width: "600px",
          padding: "24px",
        },
      }}
      onClose={closeDialog}
      maxWidth="xl"
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogContent dividers>
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <CircularProgress size={25} color="inherit" />
          </div>)}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/icons/images.svg"
            alt=""
            width="32px"
            height="32px"
          />
        </div>
        <div style={{ margin: "0% 20%" }}>
          {fileCount ? 
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", pt: "16px" }}
            color="textPrimary"
            align="center"
          >
            {fileCount} {strapiData?.ImagesText || "images"}
          </Typography>:<></>}
          <div
            style={{ textAlign: "center", paddingTop: "10px", margin: "7% -15%" }}
          >
           {strapiData?.DoYouWantToText || " Do you want to remove background from selected images before upload"}
          </div>
          <Box>
            <CustomizedButton
              type="dark"
              btnText={strapiData?.RemoveBGCTA || "Remove Background & Import"}
              onClick={longPollJobDetail}
              style={{ borderRadius: "4px" }}
              disabled={bulkUplodAIType === BULK_AI_TYPE.BULK_UPLOAD_MODEL_GEN}
            />
          </Box>
          <div style={{ display: "flex", justifyContent: "center", margin: "15px" }}>
            <img src="/icons/divider.svg" alt="divider" />
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Box width="100%">
              <CustomizedButton type="white_with_border"
                btnText={strapiData?.ImportCTA || "Import"}
                onClick={updateRawImageInEditor}
              />
            </Box>
          </div> 
        </div>
      </DialogContent>
    </Dialog>
  );
}

BatchEditorSuccessDialog.defaultProps = {
  successText: "",
};